<template>
  <div class="my-lessons">
    <h6>مرکز دانلود</h6>
    <div class="divider"></div>
    <div class="calendarBox f_s_sa col-12">
      <div class="calendar col-8 p-0 f_s_b">
        <div class="softwareName f_s_sa">
          <div
            v-for="(v, i) in data"
            :key="i"
            class="softwareNameItem f_c_c"
            :class="[software == v.name ? activeRadio : '']"
          >
            <input
              type="radio"
              :id="v.name"
              v-model="software"
              name="softwareName"
              :value="v.name"
            />
            <label class="m-0 mr-2" :for="v.name">{{ v.name }}</label>
          </div>
        </div>
        <div class="downloadBtn f_s_sa">
          <a
            v-for="(v, i) in data"
            :key="i"
            class="downloadBtnItem"
            :href="v.url"
            download
            @click="softwareBtnFunc(v.name)"
            :class="[software == v.name ? activeBtn : '']"
          >
            <div class="softwareBtn">دانلود</div>
          </a>
        </div>
      </div>
      <div class="task-class col-3 p-0 f_e_sa">
        <b-img
          class="
            lesson-class-icon
          "
          :src="require(`@/assets/images/footer-icon/cloud.svg`)"
          fluid
        ></b-img>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import mixin from "@/mixins/mixin";
export default {
  mixins: [mixin],
  name: "DownloadCenter",
  data() {
    return {
      software: "",
      isClick: null,
      activeBtn: "activeBtn",
      activeRadio: "activeRadio",
      data: [
        {
          name: "Adobe Connect 64bit",
          url: "https://dl.iauec.ac.ir/software/adobe-connect2020.exe",
        },
        {
          name: "Foxit Reader",
          url: "https://dl.iauec.ac.ir/software/newSoftware/Foxit.reader.zip",
        },
        {
          name: "AnyDesk",
          url: "https://dl.iauec.ac.ir/software/newSoftware/Anydesk.zip",
        },
        {
          name: "Flash Player - FireFox",
          url: "http://dl.iauec.ac.ir/software/newSoftware/Flash_player_f_31.exe",
        },
        {
          name: "FireFox",
          url: "https://dl.iauec.ac.ir/software/newSoftware/firefox.64.84.zip",
        },
        {
          name: "Adobe Connect Android",
          url: "https://dl.iauec.ac.ir/software/adobeconnect-android-last.apk",
        },
        {
          name: "FireFox Android",
          url: "https://dl.iauec.ac.ir/software/Firefox-Browser-56.apk",
        },
        {
          name: "Keyboard Farsi",
          url: "https://dl.iauec.ac.ir/software/keybordfarsi.zip",
        },
        {
          name: "WinRAR 64bit",
          url: "https://dl.iauec.ac.ir/software/newSoftware/Winrar.64.32.zip",
        },
      ],
    };
  },
  created() {},
  computed: {
    ...mapState({
      heightWidthValue: (state) => state.login.heightWidthValue,
    }),
  },
  components: {},
  props: {},
  methods: {
    ...mapActions("my", ["prevUrlFunction"]),
    softwareBtnFunc(v) {
      this.software = v;
    },
  },
  watch: {},
  mounted() {
    this.setHeight(this.heightWidthValue);
  },
  beforeDestroy: function () {
    this.prevUrlFunction("download-center");
  },
};
</script>
<style lang="scss" scoped>
.my-lessons {
  height: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 0.2rem 1rem;
  h6 {
    padding: 20px 10px;
    margin: 0;
  }
  .calendarBox {
    padding: 0 10px;
    height: 80%;
    .calendar {
      flex: 0 0 46.333333% !important;
      height: 100%;
      .softwareName {
        flex-direction: column;
        height: 100%;
        scroll-behavior: smooth;
        overflow: auto;
        -ms-overflow-style: none;
        scrollbar-width: none;
        &::-webkit-scrollbar {
          display: none;
        }
        .softwareNameItem {
          input {
            cursor: pointer;
            border: 2px solid white;
            box-shadow: 0 0 0 1px #707070;
            appearance: none;
            border-radius: 50%;
            width: 12px;
            height: 12px;
            margin-right: 1px;
            background-color: #fff;
            &:checked {
              background-color: #1d9dae;
              box-shadow: 0 0 0 1px #1d9dae;
            }
          }
          label {
            cursor: pointer;
            color: #707070;
          }
        }
      }
      .downloadBtn {
        flex-direction: column;
        height: 100%;
        scroll-behavior: smooth;
        overflow: auto;
        -ms-overflow-style: none;
        scrollbar-width: none;
        &::-webkit-scrollbar {
          display: none;
        }
        .downloadBtnItem {
          background-color: #707070;
          padding: 0px 15px 2px 15px;
          border-radius: 20px;
          cursor: pointer;
          color: white;
        }
      }
      .activeBtn {
        background-color: #1d9dae !important;
      }
      .activeRadio {
        color: #1d9dae !important;
        font-weight: bold;
        label{
          color: #1d9dae !important;
        }
      }
    }
    .task-class {
      position: relative;
      padding: 0 10px;
      height: 100%;
      flex-direction: column;
      .lesson-class-icon {
        width: 300px;
      }
    }
  }
}
@media (min-width: 900px) and (max-width: 1000px) {
  .my-lessons {
    .calendarBox {
      justify-content: space-between;
      .calendar {
        flex: 0 0 60.333333% !important;
      }
    }
  }
}
@media (min-width: 767px) and (max-width: 900px) {
  .my-lessons {
    .calendarBox {
      justify-content: space-between;
      .calendar {
        flex: 0 0 60.333333% !important;
      }
    }
  }
}
@media (max-width: 767px) {
  .my-lessons {
    padding: 0;
    .calendarBox {
      .calendar {
        flex: 0 0 100% !important;
        max-width: 100%;
        overflow: auto;
        -ms-overflow-style: none;
        scrollbar-width: none;
        &::-webkit-scrollbar {
          display: none;
        }
        .softwareName {
          min-height: 60vh;
          height: 100%;
        }
        .downloadBtn {
          min-height: 60vh;
          height: 100%;
        }
      }
      .task-class {
        display: none;
      }
    }
  }
}
</style>